import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import api from '../../api/client'

export default function Indicacao() {
  const { codigo } = useParams()
  const [sponsor, setSponsor] = useState(null)
  const [estado, setEstado] = useState('load')
  const [form, setForm] = useState({ nome: '', email: '', telefone: '', whatsapp: '', cidade: '', estado: '' })
  const [ok, setOk] = useState(false)
  const [err, setErr] = useState('')

  useEffect(() => {
    api.get(`/indicacao/${codigo}`).then((r) => { setSponsor(r.data); setEstado('ok') }).catch(() => setEstado('erro'))
  }, [codigo])

  async function enviar(e) {
    e.preventDefault()
    setErr('')
    try {
      await api.post(`/indicacao/${codigo}/cliente`, form)
      setOk(true)
    } catch (e2) {
      setErr(e2?.response?.data?.detail || 'Erro ao cadastrar')
    }
  }

  return (
    <div className="min-h-screen bg-tc-graphite flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full shadow-xl">
        <div className="font-heading text-xl font-extrabold text-tc-graphite mb-1">
          The Conect <span className="text-tc-orange">Energy</span>
        </div>
        {estado === 'load' && <p className="text-tc-smoke">Carregando...</p>}
        {estado === 'erro' && <p className="text-red-600">Código de indicação inválido.</p>}
        {ok && <p className="text-green-600 font-medium">✓ Cadastro realizado! Em breve entraremos em contato.</p>}
        {estado === 'ok' && !ok && (
          <>
            <p className="text-sm text-tc-smoke mb-4">Indicado por <b>{sponsor?.nome}</b></p>
            {err && <p className="text-sm text-red-600 bg-red-50 rounded px-3 py-2 mb-3">{err}</p>}
            <form onSubmit={enviar} className="space-y-3">
              <input required placeholder="Nome completo" value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} className="w-full border rounded-lg px-3 py-2" />
              <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full border rounded-lg px-3 py-2" />
              <input placeholder="Telefone" value={form.telefone} onChange={(e) => setForm({ ...form, telefone: e.target.value })} className="w-full border rounded-lg px-3 py-2" />
              <input placeholder="WhatsApp" value={form.whatsapp} onChange={(e) => setForm({ ...form, whatsapp: e.target.value })} className="w-full border rounded-lg px-3 py-2" />
              <div className="grid grid-cols-2 gap-3">
                <input placeholder="Cidade" value={form.cidade} onChange={(e) => setForm({ ...form, cidade: e.target.value })} className="border rounded-lg px-3 py-2" />
                <input placeholder="UF" maxLength="2" value={form.estado} onChange={(e) => setForm({ ...form, estado: e.target.value })} className="border rounded-lg px-3 py-2" />
              </div>
              <button className="w-full rounded-lg bg-tc-orange text-white py-2.5 font-semibold">Realizar Cadastro</button>
            </form>
          </>
        )}
      </div>
    </div>
  )
}
